import { SearchIcon } from 'foundations-assets/icons/components/SearchIcon';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import I18n from 'I18n';
import { useCallback } from 'react';
import { View } from 'foundations-components/components/View';
import { useCardContext } from '../../../context/CardContext';
import { usageTracker } from '../../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
function AssociationSearchButton({
  onSearchToggle,
  showSearchInput
}) {
  const {
    fromObjectTypeId,
    toObjectTypeId
  } = useCardContext();
  const handleSearchToggle = useCallback(() => {
    if (!showSearchInput) {
      usageTracker.track('CRM', 'Record Interactions', {
        type: 'Association Card',
        action: 'Opened Search Input',
        toObjectTypeId,
        fromObjectTypeId
      });
    }
    onSearchToggle();
  }, [onSearchToggle, fromObjectTypeId, toObjectTypeId, showSearchInput]);
  return /*#__PURE__*/_jsx(View, {
    flexShrink: 0,
    children: /*#__PURE__*/_jsx(IconButton, {
      active: showSearchInput,
      use: "tertiary-extra-light",
      size: "extra-small",
      onClick: handleSearchToggle,
      "aria-label": I18n.text('cardAssociatedObjects.AssociatedObjectsCardSearch.searchButtonAriaLabel'),
      children: /*#__PURE__*/_jsx(SearchIcon, {})
    })
  });
}
export default AssociationSearchButton;